import type { Metadata } from "next"

import { Container } from "@/components/layout/container"

export const metadata: Metadata = {
  title: "Умови використання",
  description: "Умови використання порталу Кухлик.",
}

export default function TermsOfUsePage() {
  return (
    <section className="py-12 sm:py-16">
      <Container className="max-w-4xl">
        <div className="surface p-6 sm:p-8">
          <h1 className="text-3xl font-semibold text-neutral-950 sm:text-4xl">
            Умови використання
          </h1>
          <p className="mt-5 text-sm leading-8 text-neutral-600 sm:text-base">
            Тут буде розміщено правила використання сайту, умови публікації
            матеріалів, користувацьких рецептів, коментарів і загальні юридичні
            положення.
          </p>
        </div>
      </Container>
    </section>
  )
}
